import { PwuType, ePwuType } from "./PwuType";
import { PwuManager } from "./PwuManager";
import { TextureAtlasUtils } from "../../Utils/TextuAtlasUtils";
import { Game } from "../../Game";
import { HUD } from "../Game World/HUD/HUD";
import { TIMER } from "../Gameplay";
import { Player } from "../Game World/Player/Player";

export class PwuEntity {
    /**
     * (RO) Typ powerupu
     */
    get type(): PwuType { return this._type; }
    private _type: PwuType;

    /**
     * Cas aktivace v ms
     */
    private _actTime: number;

    private static readonly _ICON_INIT_SCALE = 1.5;

    /**
     * pc.Entity s Element komponentou, ktera zobrazuje ikonu powerupu
     */
    private _icon: pc.Entity;
    private _iconTexRc: pc.Vec4 = new pc.Vec4();
    private _iconAnim: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        let atlas = Game.getTextureAtlas(0);

        this._icon = new pc.Entity("pwuIcon");
        this._icon.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: 74,
            height: 35,
            anchor: [0, 1, 0, 1],
            pivot: [0.5, 0.5]
        });

        this._icon.enabled = false;
        HUD.instance.screen.addChild(this._icon);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(type: PwuType): void {
        this._type = type;
        this._actTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reactivate(): void {
        this._actTime = TIMER.time;
        this._icon.element.enabled = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    showIcon(hudSlotId: number, iconFrameKey: string): void {
        this._icon.setLocalPosition(PwuManager.HUD_ICON_X + hudSlotId * PwuManager.HUD_ICON_WIDTH, PwuManager.HUD_ICON_Y, 0);
        this._icon.element.rect = TextureAtlasUtils.getAtlasFrameRegion(Game.getTextureAtlas(0), iconFrameKey, this._iconTexRc);
        this._icon.setLocalScale(PwuEntity._ICON_INIT_SCALE, PwuEntity._ICON_INIT_SCALE, PwuEntity._ICON_INIT_SCALE);
        this._icon.element.enabled = true;
        this._icon.enabled = true;
        this._iconAnim = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._icon.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        let remTime = (this._actTime + this._type.lifeLen) - TIMER.time;

        if (remTime <= 0) {
            this.reset();
            return false;
        }

        if (remTime < 2000) {
            // Blikat s ikonou
            let visible = ((~~(remTime / 100)) & 1) != 0;

            if (this._icon.element.enabled != visible)
                this._icon.element.enabled = visible;
        }

        // Zobrazeni ikony
        if (this._iconAnim) {
            let i = (TIMER.time - this._actTime) / 500;

            if (i >= 1) {
                i = 1;
                this._iconAnim = false;
            }

            i = PwuEntity._ICON_INIT_SCALE - (PwuEntity._ICON_INIT_SCALE - 1) * pc.ElasticOut(i);
            this._icon.setLocalScale(i, i, i);
        }

        return true;
    }
}